// Connections service - handles all connection/network-related API calls
import api from './api';

export const connectionsService = {
  // Get all connections
  getConnections: async () => {
    const response = await api.get('/connections');
    return response.data;
  },

  // Get connection requests (received)
  getConnectionRequests: async () => {
    const response = await api.get('/connections/requests');
    return response.data;
  },

  // Get sent connection requests
  getSentRequests: async () => {
    const response = await api.get('/connections/sent');
    return response.data;
  },

  // Send connection request
  sendConnectionRequest: async (userId) => {
    const response = await api.post('/connections/request', { userId });
    return response.data;
  },

  // Accept connection request
  acceptConnectionRequest: async (connectionId) => {
    const response = await api.put(`/connections/${connectionId}/accept`);
    return response.data;
  },

  // Reject connection request
  rejectConnectionRequest: async (connectionId) => {
    const response = await api.put(`/connections/${connectionId}/reject`);
    return response.data;
  },

  // Remove connection
  removeConnection: async (connectionId) => {
    const response = await api.delete(`/connections/${connectionId}`);
    return response.data;
  },

  // Get suggested connections
  getSuggestedConnections: async () => {
    const response = await api.get('/connections/suggestions');
    return response.data;
  },

  // Check connection status with a user
  getConnectionStatus: async (userId) => {
    const response = await api.get(`/connections/status/${userId}`);
    return response.data;
  },

  // Follower-related methods
  getFollowers: async () => {
    const response = await api.get('/followers');
    return response.data;
  },

  getFollowing: async () => {
    const response = await api.get('/followers/following');
    return response.data;
  },

  followUser: async (userId) => {
    const response = await api.post('/followers/follow', { userId });
    return response.data;
  },

  unfollowUser: async (userId) => {
    const response = await api.post('/followers/unfollow', { userId });
    return response.data;
  },

  checkFollowStatus: async (userId) => {
    const response = await api.get(`/followers/status/${userId}`);
    return response.data;
  },

  // Stats methods
  getStats: async () => {
    const response = await api.get('/followers/stats');
    return response.data;
  },

  getUserStats: async (userId) => {
    const response = await api.get(`/followers/stats/${userId}`);
    return response.data;
  },

  // Helper methods to match ConnectionsContext expectations
  sendRequest: async (userId) => {
    return connectionsService.sendConnectionRequest(userId);
  },

  acceptRequest: async (connectionId) => {
    return connectionsService.acceptConnectionRequest(connectionId);
  },

  rejectRequest: async (connectionId) => {
    return connectionsService.rejectConnectionRequest(connectionId);
  },

  checkConnectionStatus: async (userId) => {
    return connectionsService.getConnectionStatus(userId);
  },
};

export default connectionsService;
